import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SEO } from "@/components/site/SEO";
import { JsonLd, organizationSchema, websiteSchema, webPageSchema } from "@/components/site/Schema";
import { Hero } from "@/components/site/Hero";
import { ProblemSection } from "@/components/site/ProblemSection";
import { EditorialStatement } from "@/components/site/EditorialStatement";
import { FounderIntro } from "@/components/site/FounderIntro";
import { AuthorizedPractitionerBanner } from "@/components/site/AuthorizedPractitionerBanner";
import { FivePillarsSection } from "@/components/site/FivePillarsSection";
import { FamilyBankingFoundation } from "@/components/site/FamilyBankingFoundation";
import { InfiniteBankingIntro } from "@/components/site/InfiniteBankingIntro";
import { VideoSection } from "@/components/site/VideoSection";
import { ClientJourneySection } from "@/components/site/ClientJourneySection";
import { PolicyReviewSection } from "@/components/site/PolicyReviewSection";
import { Testimonials } from "@/components/site/Testimonials";
import { PolicyStackSection } from "@/components/site/PolicyStackSection";
import { LearningSection } from "@/components/site/LearningSection";
import { BookFeature } from "@/components/site/BookFeature";
import { ClosingConversion } from "@/components/site/ClosingConversion";
import { StickyCta } from "@/components/site/StickyCta";
import { MotionConfig } from "framer-motion";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-ivory" data-testid="home-page">
      <SEO title="Legacy Life & Retirement | Financial Clarity & Family Banking" description="Build a coordinated financial system for more control today and more opportunities tomorrow with Legacy Life & Retirement." />
      <JsonLd id="ld-organization" data={organizationSchema()} />
      <JsonLd id="ld-website" data={websiteSchema()} />
      <JsonLd id="ld-home-webpage" data={webPageSchema({ path: "/", name: "Legacy Life & Retirement" })} />
      <MotionConfig reducedMotion="user">
        <Header />
        <main>
          <Hero />
          <ProblemSection />
          <EditorialStatement />
          <FounderIntro />
          <AuthorizedPractitionerBanner />
          <Testimonials />
          <FivePillarsSection />
          <FamilyBankingFoundation />
          <InfiniteBankingIntro />
          <VideoSection />
          <ClientJourneySection />
          <PolicyReviewSection />
          <PolicyStackSection />
          <LearningSection />
          <BookFeature />
          <ClosingConversion />
        </main>
        <Footer />
        <StickyCta />
      </MotionConfig>
    </div>
  );
}
